import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1 className="mt-5 text-center">
        <span className="text-danger">404 Error!</span> Page not found.
      </h1>
    </div>
  );
};

export default ErrorPage;
